import { useQuery } from 'react-query';
import { commercialInProgressConsultationsQuery } from './useCommercialInProgressConsultations.query';
import {
  UseCommercialConsultationsQueryParams,
  UseCommercialConsultationsResponse,
} from './useCommercialInProgressConsultations.types';

export const ALL_COMMERCIAL_IN_PROGRESS_CONSULTATIONS_QUERY_KEY =
  'ALL_COMMERCIAL_IN_PROGRESS_CONSULTATIONS';

export const useCommercialInProgressConsultations = (
  params: UseCommercialConsultationsQueryParams
) => {
  return useQuery<UseCommercialConsultationsResponse, Error>(
    [ALL_COMMERCIAL_IN_PROGRESS_CONSULTATIONS_QUERY_KEY, params],
    () => commercialInProgressConsultationsQuery(params),
    {
      retry: false,
    }
  );
};
